import React from 'react';

import { useCurrentuser } from '@uplift/contexts';
import { useAggregateAppointmentCounts } from '@uplift/queries';

import { TodaySessionItem } from './today-session-item.component';
import { TodaysAppointmentWithPatient } from '../hooks/use-todays-appointments.hook';
import { StackableCardDeck } from '@uplift/ui-v2';

type SessionListProps = {
  refreshOnUpdate?: () => void;
  sessions: TodaysAppointmentWithPatient[];
};

export const SessionsList: React.FC<SessionListProps> = ({
  sessions,
  refreshOnUpdate,
}) => {
  const me = useCurrentuser();
  const { patientCounts } = useAggregateAppointmentCounts(me?.id);

  return (
    <StackableCardDeck>
      {sessions.map((appointmentWithPatient) => {
        const sessionCount = patientCounts?.[appointmentWithPatient.patient?.id]?.length;

        return (
          <TodaySessionItem
            key={appointmentWithPatient.appointment.id}
            appointmentWithPatient={appointmentWithPatient}
            sessionCount={sessionCount}
            refreshOnUpdate={refreshOnUpdate}
          />
        );
      })}
    </StackableCardDeck>
  );
};
